
import React, { useState, useEffect } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { message, Input, DatePicker } from "antd";
import PageHeader from "../../Routes/PageHeader";
import { API } from "../../Config";
import LoadingBox from "../../Components/LoadingBox";
import FormModalJournal from "../VoucherScreen/formJournal";
import FormModal from "../VoucherScreen/FormModal";
import DataTable from "../VoucherScreen/DataTable";
import FormModalReciept from "./FormReceipt";
import { GET, DELETE } from "../../Config/ApiRequests";

const { RangePicker } = DatePicker;

const Voucher = () => {
  const { page_mode } = useParams();
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [indicator, setIndicator] = useState(false);
  const [form, setform] = useState(false);
  const [mode, setMode] = useState("post");
  const [head, setHead] = useState("");
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState({});
  const [item, setItem] = useState({});
  const [accounts, setAccounts] = useState([]);
  const [columnsVisible, setColumnsVisible] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);

  useEffect(() => {
    switch (page_mode) {
      case "RV":
        setColumnsVisible({
          page: "Receipt Voucher",
          short: "RV",
          amount_cr: true,
          amount_dr: false,
          accounts: true,
        });
        break;
      case "PV":
        setColumnsVisible({
          page: "Payment Voucher",
          short: "PV",
          amount_cr: true,
          amount_dr: true,
          accounts: true,
        });
        break;
      case "JV":
        setColumnsVisible({
          page: "Journal Voucher",
          short: "JV",
          amount_cr: true,
          amount_dr: true,
          accounts: false,
        });
        break;
      default:
        break;
    }

    const params = new URLSearchParams(location.search);
    const page = Number(params.get("page")) || 1;
    const take = Number(params.get("take")) || 10;
    const search = params.get("search") || "";
    const dateFrom = params.get("dateFrom") || "";
    const dateTo = params.get("dateTo") || "";

    setSearchTerm(search);
    loaddata(page, take, search, dateFrom, dateTo);
    AccountsDropdown();
  }, [page_mode, location.search]);

  const loaddata = async (p, t, search = "", dateFrom = "", dateTo = "") => {
    let url = `${API.VOUCHER_LIST}/${page_mode}?order=DESC&page=${p}&take=${t}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    if (dateFrom) url += `&dateFrom=${dateFrom}`;
    if (dateTo) url += `&dateTo=${dateTo}`;
    try {
      const response = await GET(url);
      const payload = response || {};
      setData(payload.data || []);
      setMeta(payload.meta || {});
    } catch (error) {
      message.error("Oops. Something went wrong");
    } finally {
      setLoading(false);
      setIndicator(false);
    }
  };

  const updateUrl = (page, take, search, dateFrom = "", dateTo = "") => {
    const params = new URLSearchParams();
    if (page > 1) params.set("page", page);
    if (take !== 10) params.set("take", take);
    if (search) params.set("search", search);
    if (dateFrom) params.set("dateFrom", dateFrom);
    if (dateTo) params.set("dateTo", dateTo);
    history.replace(params.toString() ? `${location.pathname}?${params}` : location.pathname);
  };

  const AccountsDropdown = () => {
    GET(API.CHART_OF_ACCOUNTS_LIST + `/child_accounts`)
      .then((res) => setAccounts(res))
      .catch((error) => message.error(error.message));
  };

  const pagination = (page, pageSize) => {
    window.scrollTo(0, 0);
    setIndicator(true);
    const params = new URLSearchParams(location.search);
    const dateFrom = params.get("dateFrom") || "";
    const dateTo = params.get("dateTo") || "";
    updateUrl(page, pageSize, searchTerm, dateFrom, dateTo);
  };

  const relaod = () => {
    const params = new URLSearchParams(location.search);
    const page = Number(params.get("page")) || 1;
    const take = Number(params.get("take")) || 10;
    const search = params.get("search") || "";
    loaddata(page, take, search);
    setMode("post");
    setItem({});
    setform(false);
  };

  const AddItem = () => {
    setMode("post");
    setItem({});
    setform(true);
  };

  const ViewItem = (item) => {
    // Map page_mode to route prefix (PV->VoucherPv, RV->VoucherRv, JV->VoucherJv)
    const routePrefix = `Voucher${page_mode.charAt(0)}${page_mode.charAt(1).toLowerCase()}`;
    history.push(`/auth/${routePrefix}/${page_mode}/view/${item.id}`);
  };

  const UpdateItem = (item) => {
    setMode("put");
    setItem(item);
    setform(true);
  };

  const DeleteItem = async (item) => {
    setIndicator(true);
    try {
      await DELETE(API.VOUCHER_ACTIONS + item.id);
      message.success("Deleted Successfully");
      relaod();
    } catch (error) {
      message.error(error.message);
    } finally {
      setIndicator(false);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    const params = new URLSearchParams(location.search);
    const take = Number(params.get("take")) || 10;
    const dateFrom = params.get("dateFrom") || "";
    const dateTo = params.get("dateTo") || "";
    updateUrl(1, take, value, dateFrom, dateTo);
  };

  const handleDateChange = (dates) => {
    setDateRange(dates);
    const params = new URLSearchParams(location.search);
    const take = Number(params.get("take")) || 10;
    const dateFrom = dates?.[0] ? dates[0].format("YYYY-MM-DD") : "";
    const dateTo = dates?.[1] ? dates[1].format("YYYY-MM-DD") : "";
    updateUrl(1, take, searchTerm, dateFrom, dateTo);
  };

  return (
    <div>
      <PageHeader
        PageName={head}
        breadScrum={`Admin / ${columnsVisible.page}`}
        RightButton={`New / ${columnsVisible.page}`}
        RightClcik={() => AddItem()}
        loader={indicator}
      />
      <div style={{ marginBottom: 16, display: "flex", gap: 16, alignItems: "center" }}>
        <Input
          placeholder="Search by Airway Bill Number"
          value={searchTerm}
          onChange={handleSearch}
          style={{ width: 300 }}
        />
        <RangePicker
          value={dateRange}
          onChange={handleDateChange}
          format="DD/MM/YYYY"
          placeholder={["Start Date", "End Date"]}
          allowClear
        />
      </div>
      {loading ? (
        <LoadingBox />
      ) : (
        <div>
          <DataTable
            columnsVisible={columnsVisible}
            meta={meta}
            data={data}
            view={(item) => ViewItem(item)}
            update={(item) => UpdateItem(item)}
            delete={(item) => DeleteItem(item)}
            PageOnchange={(page, pageSize) => pagination(page, pageSize)}
          />

          {form && page_mode === "RV" && (
            <FormModalReciept
              page_mode={page_mode}
              accounts={accounts}
              head={head}
              item={item}
              mode={mode}
              visible={form}
              columnsVisible={columnsVisible}
              onchange={() => relaod()}
              onClose={() => setform(false)}
            />
          )}
          {form && page_mode === "PV" && (
            <FormModal
              page_mode={page_mode}
              accounts={accounts}
              head={head}
              item={item}
              mode={mode}
              visible={form}
              columnsVisible={columnsVisible}
              onchange={() => relaod()}
              onClose={() => setform(false)}
            />
          )}

          {form && page_mode === "JV" && (
            <FormModalJournal
              page_mode={page_mode}
              accounts={accounts}
              head={head}
              item={item}
              mode={mode}
              visible={form}
              columnsVisible={columnsVisible}
              onchange={() => relaod()}
              onClose={() => setform(false)}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default Voucher;
